import { ServiceData } from '@/types';

import articles from './COOKING_ARTICLES_SE.json';
import recipes from './COOKING_RECIPES_SE.json';
import videos from './COOKING_VIDEOS_SE.json';

export const COOKING_DATA_SE: ServiceData = {
  articles,
  recipes,
  videos,
};
